
import { defineComponent, ref, onMounted, onUpdated, PropType } from "vue";
import { QueryString } from "../models/queryString";
import { parseQueryString } from "../common/urlHelpers";
export default defineComponent({
  props: {
    tagGroups: {
      type: [],
      required: true,
      default: []
    },
    selectedTags: {
      type: Array as PropType<
        {
          categoryId: string;
          count?: number;
          id: string;
          title: string;
        }[]
      >,
      required: true,
      default: []
    }
  },
  setup(props, context) {
    const selectedTaxonomyIndex = ref(-1);
    const qsParsed = ref(false);

    const updateTagsFromQS = (tagIDs: string[]): void => {
      const selectedTags: {
        id: string;
        categoryId: string;
        title: string;
        count: undefined;
      }[] = [];
      props.tagGroups.forEach(tagGroup => {
        tagGroup.tags.forEach(tag => {
          if (tagIDs.includes(tag.id)) {
            selectedTags.push({
              title: tag.title,
              id: tag.id,
              categoryId: tagGroup.id,
              count: undefined
            });
          }
        });
      });
      if (selectedTags.length > 0) {
        context.emit("selectedTagsUpdated", selectedTags);
        context.emit("tagUpdated", selectedTags);
      }
    };

    const checkQS = (): void => {
      if (props.tagGroups.length > 0 && !qsParsed.value) {
        const qsParams: QueryString = parseQueryString();
        for (const paramKey in qsParams) {
          if (paramKey === "tags") {
            updateTagsFromQS(qsParams[paramKey].split(","));
          }
        }
        qsParsed.value = true;
      }
    };

    onMounted(() => {
      checkQS();
    });

    onUpdated(() => {
      checkQS();
    });

    const selectTag = (taxonomyId, option) => {
      const st = props.selectedTags as {
        categoryId: string;
        count?: number;
        id: string;
        title: string;
      }[];
      const checkedTag = {
        title: option.title,
        id: option.id,
        categoryId: taxonomyId,
        count: option.count
      };
      if (st.filter(x => x.id === checkedTag.id).length === 0) {
        const updatedTags = [...st, checkedTag];
        context.emit("selectedTagsUpdated", updatedTags);
      } else {
        context.emit(
          "selectedTagsUpdated",
          st.filter(x => x.id !== checkedTag.id)
        );
      }
    };

    const removeWhitespace = a => {
      return a
        .toLowerCase()
        .split(" ")
        .join("");
    };

    const showHideTaxonomy = (taxonomyIndex: number): void => {
      if (taxonomyIndex === selectedTaxonomyIndex.value) {
        selectedTaxonomyIndex.value = -1;
      } else {
        selectedTaxonomyIndex.value = taxonomyIndex;
      }
    };

    return {
      selectTag,
      removeWhitespace,
      showHideTaxonomy,
      selectedTaxonomyIndex
    };
  }
});
